import React from 'react';
import { StarIcon } from 'lucide-react';
import { SectionHeader } from '../ui/SectionHeader';
import { CTAButton } from '../ui/CTAButton';
import { testimonials } from '../../data/testimonials';
export function Testimonials() {
  return <section className="w-full bg-paper px-4 py-16 md:py-24" data-id="element-275" data-mp="3mfhg84kwlvhq">
      <div className="mx-auto max-w-6xl" data-id="element-276" data-mp="3r7sez43wrb8p">
        <SectionHeader kicker="What professionals think" title="A Structured Approach to Hair Restoration Education" intro={['Professional educational resources should be organized, relevant, and clear about what they offer.']} data-id="element-277" data-mp="3r8tvho3p0pxt" />

        <div className="mt-12 grid gap-5 md:grid-cols-2 lg:grid-cols-3" data-id="element-278" data-mp="92xi2xz4dgd5">
          {testimonials.map(t => <figure key={t.name} className="flex flex-col rounded-3xl bg-white p-6 shadow-card" data-id="element-279" data-mp="e0gya3fdo37q">
              <div className="flex items-center gap-4" data-id="element-280" data-mp="2autu08p78s8g">
                <img src={t.image} alt={t.name} className="h-16 w-16 shrink-0 rounded-full object-cover ring-4 ring-paper" loading="lazy" data-id="element-281" data-mp="2fru18mxsc115" />
                <div className="min-w-0" data-id="element-282" data-mp="1nsrjsjd5rq39">
                  <p className="font-display text-lg font-black leading-tight text-heading" data-id="element-283" data-mp="1nrzq5e34g2fm">{t.name}</p>
                  <p className="text-sm text-body" data-id="element-284" data-mp="1isdfnceoh0ai">{t.profile}</p>
                </div>
              </div>
              <div className="mt-5 flex gap-0.5" aria-label="5 out of 5 stars" data-id="element-285" data-mp="2bjeufcegktti">
                {Array.from({
              length: 5
            }).map((_, i) => <StarIcon key={i} className="h-5 w-5 fill-gold text-gold" aria-hidden="true" data-id="element-286" data-mp="26ldayqd4eshi" data-mpi={i} />)}
              </div>
              <h3 className="mt-3 font-display text-lg font-black leading-snug text-heading" data-id="element-287" data-mp="22kti3yzkyb16">“{t.title}”</h3>
              <blockquote className="mt-2 text-[16px] leading-relaxed text-body" data-id="element-288" data-mp="1xlynlzs92y18">“{t.quote}”</blockquote>
            </figure>)}
        </div>

        <div className="mt-12" data-id="element-289" data-mp="m3fftfs2mc6h">
          <CTAButton label="Explore the complete collection" sub="One-time payment · $27 USD · Digital product" tone="light" data-id="element-290" data-mp="m35s5yui0h3y" />
        </div>
      </div>
    </section>;
}